/**
 * Named z-index scale. Same values as the CSS custom properties in
 * index.css and the Tailwind theme.zIndex extension in tailwind.config.js —
 * use this file for numeric `zIndex` props (e.g. <Modal zIndex={...}>);
 * use the matching `z-*` Tailwind class for everything else. Pick the tier
 * that matches what you're layering above; don't invent a bigger number.
 */
export const Z_INDEX = {
  /** In-canvas chart overlays: crosshair/axis labels, legend. */
  chartOverlay: 10,
  /** Content that must sit above decorative background layers. */
  raised: 20,
  /** Lightweight panel-level backdrops (side panels, alerts). */
  panelBackdrop: 30,
  /** Slide-in drawer backdrop (e.g. chart settings panel). */
  drawerBackdrop: 40,
  /** Dropdowns, popovers, tooltips, and the base modal layer. */
  dropdown: 50,
  /** A modal opened from within an already-open panel/modal. */
  modalElevated: 60,
  /** That modal's own dialog, one above its own backdrop. */
  modalElevatedDialog: 61,
  /** An overlay that must sit above an already-elevated modal. */
  modalStacked: 70,
  /** App-shell-level critical overlays. */
  criticalOverlay: 100,
  /** Click-outside catcher for small inline colour swatch pickers. */
  swatchCatcher: 9,
  /** Click-outside catcher for a floating popover (ColorPicker). */
  floatingBackdrop: 9998,
  /** Floating popover content that must beat nearly everything (ColorPicker, DrawingToolbar flyout, VolumeSpikeStrip). */
  floatingPopover: 9999,
  /** Must render above absolutely everything else. */
  topmost: 10000,
} as const;
